import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "@aws-amplify/ui-react/styles.css";

import { Amplify } from "aws-amplify";
import config from "./config/aws-exports";
import { ThemeProvider } from "@aws-amplify/ui-react";

Amplify.configure(config);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider>
    <App />
  </ThemeProvider>
);
